import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loading } from "src/components";
import { UIService } from "src/services";
import { Pages, PagesAction } from "src/store";

export const AboutUs: React.FC = () => {

    //#region dependencies

    const dispatch = useDispatch();
    const pages: Pages = useSelector((state: any) => state.PagesState);
    const isEmbedded = UIService.isEmbedded();


    //#end region

    //#region effects

    useEffect(() => {

        if (!pages.aboutUs.loaded) {
            dispatch(PagesAction.requestAboutUs());
        }

    }, [dispatch, pages.aboutUs.loaded]);

    //#end region

    return (
        <div className="page-about-us app-theme2">
            {!isEmbedded &&
                <div className="cover d-flex">
                    <div className="container d-flex">
                        <h1>
                            <span>{pages.aboutUs.title}</span>
                        </h1>
                    </div>
                </div>
            }
            <div className="container large-container content pb-5">
                {isEmbedded && <h1 className="text-rtl page-title">{pages.aboutUs.title}</h1>}
                {
                    !pages.aboutUs.loaded &&
                    <div className="container program-page app-theme2 p-0 p-md-2 py-4 my-4">
                        <div className="py-4 my-4">
                            <Loading />
                        </div>
                    </div>
                }
                <div dangerouslySetInnerHTML={{ __html: pages.aboutUs.htmlBody }}></div>
            </div>
        </div>
    );
};